import React, { useEffect, useState } from 'react';
import { savedEventsStore } from './savedEvents';

export default function HeartButton({ event, disabled = false, onToggle, style = {} }) {
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function refresh() {
      const hasEvent = event?.id ? await savedEventsStore.has(event.id) : false;
      if (!cancelled) {
        setSaved(hasEvent);
      }
    }

    refresh();
    return () => {
      cancelled = true;
    };
  }, [event?.id]);

  const handleClick = async (clickEvent) => {
    if (clickEvent) {
      clickEvent.preventDefault();
      clickEvent.stopPropagation();
    }

    if (!event || disabled) {
      return;
    }

    const savedId = event.id || event.slug || event._id;

    if (!savedId) {
      return;
    }

    const nextSaved = !saved;

    if (nextSaved) {
      const consentKey = 'frolik_saved_events_notice_seen';
      if (!window.localStorage.getItem(consentKey)) {
        window.localStorage.setItem(consentKey, '1');
        window.alert('Saved on this device only. Clearing browser data or switching devices removes these. No account, no tracking.');
      }

      await savedEventsStore.add(event);
    } else {
      await savedEventsStore.remove(savedId);
    }

    setSaved(nextSaved);
    onToggle?.(nextSaved, event);
  };

  return (
    <button
      type="button"
      aria-label={saved ? 'Remove saved event' : 'Save event'}
      onClick={handleClick}
      style={{
        ...baseStyle,
        ...(saved ? activeStyle : {}),
        ...(disabled ? disabledStyle : {}),
        ...style,
      }}
      disabled={disabled}
      title={
        disabled
          ? 'Sign in to save this event'
          : saved
            ? 'Remove from saved events'
            : 'Save on this device only'
      }
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 16 16"
        width="14"
        height="14"
        shapeRendering="crispEdges"
      >
        <path
          fill="currentColor"
          d="M2 1h4v1h1v2h2V2h1V1h4v1h1v5h-1v2h-1v1h-1v1h-1v1h-1v1H9v1H7v-1H6v-1H5v-1H4v-1H3V9H2V7H1V3h1z"
        />
      </svg>
    </button>
  );
}

const baseStyle = {
  position: 'absolute',
  top: 10,
  right: 10,
  zIndex: 8,
  width: 36,
  height: 36,
  borderRadius: '50%',
  border: '1px solid rgba(17, 24, 39, 0.25)',
  background: 'rgba(255,255,255,0.88)',
  color: '#111827',
  fontSize: 18,
  lineHeight: 1,
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
};

const activeStyle = {
  background: '#111827',
  color: '#fff',
};

const disabledStyle = {
  opacity: 0.5,
  cursor: 'not-allowed',
};
